import { Check2 } from 'react-bootstrap-icons';
import type { SuggestionResponse } from '../../lib/types';
import './suggestionChips.scss';

interface SuggestionChipsProps {
  suggestions: SuggestionResponse[];
  onSelect: (suggestionId: string, text: string) => void;
}

const SuggestionChips = ({ suggestions, onSelect }: SuggestionChipsProps) => {
  if (!suggestions.length) {
    return null;
  }

  return (
    <div className="chat-suggestion-chips">
      <div className="chat-suggestion-chips__track">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion.id}
            type="button"
            className={`chat-suggestion-chips__chip${
              suggestion.selected
                ? ' chat-suggestion-chips__chip--selected'
                : ''
            }`}
            onClick={() => onSelect(suggestion.id, suggestion.text)}
          >
            {suggestion.selected ? (
              <Check2 size={18} className="chat-suggestion-chips__chip-icon" />
            ) : null}
            <span className="chat-suggestion-chips__chip-text">
              {suggestion.text}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestionChips;
